import { render, staticRenderFns } from "./SaleEditSaveModalDefaultSettings.vue?vue&type=template&id=fbab31d0&scoped=true"
import script from "./SaleEditSaveModalDefaultSettings.vue?vue&type=script&lang=ts"
export * from "./SaleEditSaveModalDefaultSettings.vue?vue&type=script&lang=ts"
import style0 from "./SaleEditSaveModalDefaultSettings.vue?vue&type=style&index=0&id=fbab31d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbab31d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbab31d0')) {
      api.createRecord('fbab31d0', component.options)
    } else {
      api.reload('fbab31d0', component.options)
    }
    module.hot.accept("./SaleEditSaveModalDefaultSettings.vue?vue&type=template&id=fbab31d0&scoped=true", function () {
      api.rerender('fbab31d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sales/SaleEditSaveModalDefaultSettings.vue"
export default component.exports